module.exports = window["material-ui"];


//////////////////
// WEBPACK FOOTER
// external "window[\"material-ui\"]"
// module id = 32
// module chunks = 0 1 2 3 4 5 6 7